import { useEffect } from "react";

// Adds robots noindex/nofollow meta tags while a protected page is mounted,
// so search engines do not index admin / warehouse routes.
export default function useNoIndex() {
  useEffect(() => {
    const make = (name) => {
      const el = document.createElement("meta");
      el.setAttribute("name", name);
      el.setAttribute("content", "noindex, nofollow, noarchive");
      document.head.appendChild(el);
      return el;
    };
    const robots = make("robots");
    const googlebot = make("googlebot");
    return () => {
      robots.remove();
      googlebot.remove();
    };
  }, []);
}
